<div class="content-container col-xs-12">
  <ol class="breadcrumb">
    <li><a href="">{{'global.menu.home' | translate}}</a></li>
    <li><a href="">{{'global.menu.fundSwitching' | translate}}</a></li>
    <li class="active">{{'personalInformation.update' | translate}}</li>
  </ol>

  <div class="content">
  </div>
</div>
